import React from 'react'
import { GetFormattedMessage } from '../../../utils/htmlHelper'

export const InsufficientDataComponent = (): JSX.Element => {
  return (
    <div style={{ textAlign: "center" }}>
      <p style={{ fontSize: 20, fontWeight: 'bold' }}>{GetFormattedMessage('app.reports.insuficient_data')}</p>
    </div>
  )
}